import "servicestack/tags/navigator/tag-navigator.scss";
import "servicestack/tags/navigator/tag-navigator.client.scss";
import controller from "servicestack/tags/navigator/tag-navigator.controller";
import templateUrl from "servicestack/tags/navigator/tag-navigator.htm";

export default {
  bindings: {
    levels: "=?",
    currentLevel: "=?",
    formatter: "<?",
    navs: "<",
    baseTagCriteria: "<?",
    maxHeight: "<?",
    maxColumnWidth: "<?",
    sortingCriteria: "<?",
    layout: "@", //drawer, drawers, accordion, wrapped-accordion, none/transclude
    tagTotalsUrl: "@",
    viewAllLabel: "@",
    stateTo: "@",
    stateParams: "<?",
    onClose: "&",
    onLoaded: "&",
    onCleared: "&",
    onDrilledDown: "&",
    onSelected: "&",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
